///
/// EarthBrowser
///
/// Migration v16 to v17: Add local data directory
///
/// Adds field for managing local data directory:
/// - localDataDirectoryId: stores the directory handle ID (persisted)
///
/// Note: Scan results (files, lastScan, errors) are stored in transient
/// dialogSlice state and re-scanned on launch
///

export const migrateV16toV17 = (state: unknown): unknown => {
	return {
		...(state as Record<string, unknown>),
		localDataDirectoryId: null,
	}
}
